import {
  listPublicPlans as publicListPublicPlans,
  queryPublicPlans as publicQueryPublicPlans,
  typedQueryPublicPlans as publicTypedQueryPublicPlans,
  getPlan as publicGetPlan,
  listPlans as publicListPlans,
  getPlanStats as publicGetPlanStats,
  createPlan as publicCreatePlan,
  updatePlan as publicUpdatePlan,
  setPlanVisibility as publicSetPlanVisibility,
  makePlanPrimary as publicMakePlanPrimary,
  clearPrimary as publicClearPrimary,
  archivePlan as publicArchivePlan,
} from './pricing-plans-v2-plan-plans.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  PlanQuery,
  PlansQueryBuilder,
  typedQueryPublicPlans as universalTypedQueryPublicPlans,
} from './pricing-plans-v2-plan-plans.universal.js';
import { onPlanBuyerCanCancelUpdated as publicOnPlanBuyerCanCancelUpdated } from './pricing-plans-v2-plan-plans.public.js';
import { onPlanCreated as publicOnPlanCreated } from './pricing-plans-v2-plan-plans.public.js';
import { onPlanArchived as publicOnPlanArchived } from './pricing-plans-v2-plan-plans.public.js';
import { onPlanUpdated as publicOnPlanUpdated } from './pricing-plans-v2-plan-plans.public.js';

function customQueryPublicPlans(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryPublicPlans(httpClient)(),
    typedQueryFunction: (query: PlanQuery) =>
      publicTypedQueryPublicPlans(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): PlansQueryBuilder;
  function overloadedQuery(
    query: PlanQuery
  ): ReturnType<typeof universalTypedQueryPublicPlans>;
  function overloadedQuery(query?: PlanQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const listPublicPlans: MaybeContext<
  BuildRESTFunction<typeof publicListPublicPlans> & typeof publicListPublicPlans
> = /*#__PURE__*/ createRESTModule(publicListPublicPlans);
export const getPlan: MaybeContext<
  BuildRESTFunction<typeof publicGetPlan> & typeof publicGetPlan
> = /*#__PURE__*/ createRESTModule(publicGetPlan);
export const listPlans: MaybeContext<
  BuildRESTFunction<typeof publicListPlans> & typeof publicListPlans
> = /*#__PURE__*/ createRESTModule(publicListPlans);
export const getPlanStats: MaybeContext<
  BuildRESTFunction<typeof publicGetPlanStats> & typeof publicGetPlanStats
> = /*#__PURE__*/ createRESTModule(publicGetPlanStats);
export const createPlan: MaybeContext<
  BuildRESTFunction<typeof publicCreatePlan> & typeof publicCreatePlan
> = /*#__PURE__*/ createRESTModule(publicCreatePlan);
export const updatePlan: MaybeContext<
  BuildRESTFunction<typeof publicUpdatePlan> & typeof publicUpdatePlan
> = /*#__PURE__*/ createRESTModule(publicUpdatePlan);
export const setPlanVisibility: MaybeContext<
  BuildRESTFunction<typeof publicSetPlanVisibility> &
    typeof publicSetPlanVisibility
> = /*#__PURE__*/ createRESTModule(publicSetPlanVisibility);
export const makePlanPrimary: MaybeContext<
  BuildRESTFunction<typeof publicMakePlanPrimary> & typeof publicMakePlanPrimary
> = /*#__PURE__*/ createRESTModule(publicMakePlanPrimary);
export const clearPrimary: MaybeContext<
  BuildRESTFunction<typeof publicClearPrimary> & typeof publicClearPrimary
> = /*#__PURE__*/ createRESTModule(publicClearPrimary);
export const archivePlan: MaybeContext<
  BuildRESTFunction<typeof publicArchivePlan> & typeof publicArchivePlan
> = /*#__PURE__*/ createRESTModule(publicArchivePlan);
export const queryPublicPlans: MaybeContext<
  BuildRESTFunction<typeof customQueryPublicPlans> &
    typeof customQueryPublicPlans
> = /*#__PURE__*/ createRESTModule(customQueryPublicPlans);
/**
 * Triggered when a plan's `buyerCanCancel` field is updated.
 * @deprecated
 */
export const onPlanBuyerCanCancelUpdated: BuildEventDefinition<
  typeof publicOnPlanBuyerCanCancelUpdated
> &
  typeof publicOnPlanBuyerCanCancelUpdated = createEventModule(
  publicOnPlanBuyerCanCancelUpdated
);
/**
 * Triggered when a pricing plan is created.
 */
export const onPlanCreated: BuildEventDefinition<typeof publicOnPlanCreated> &
  typeof publicOnPlanCreated = createEventModule(publicOnPlanCreated);
/**
 * Triggered when a pricing plan is archived.
 * @deprecated
 */
export const onPlanArchived: BuildEventDefinition<typeof publicOnPlanArchived> &
  typeof publicOnPlanArchived = createEventModule(publicOnPlanArchived);
/**
 * Triggered when a pricing plan is updated.
 * @deprecated
 */
export const onPlanUpdated: BuildEventDefinition<typeof publicOnPlanUpdated> &
  typeof publicOnPlanUpdated = createEventModule(publicOnPlanUpdated);

export {
  PeriodUnit,
  AppliedAt,
  SortOrder,
  ArchivedFilter,
  PublicFilter,
  WebhookIdentityType,
} from './pricing-plans-v2-plan-plans.universal.js';
export {
  Plan,
  StringList,
  Pricing,
  PricingPricingModelOneOf,
  Recurrence,
  Duration,
  Money,
  FeeConfig,
  Fee,
  ListPublicPlansRequest,
  ListPublicPlansResponse,
  PublicPlan,
  PagingMetadataV2,
  Cursors,
  QueryPublicPlansRequest,
  QueryV2,
  Sorting,
  Paging,
  QueryPublicPlansResponse,
  GetPlanRequest,
  GetPlanResponse,
  ListPlansRequest,
  ListPlansResponse,
  GetPlanStatsRequest,
  GetPlanStatsResponse,
  CreatePlanRequest,
  CreatePlanResponse,
  UpdatePlanRequest,
  UpdatePlanResponse,
  BuyerCanCancelUpdated,
  SetPlanVisibilityRequest,
  SetPlanVisibilityResponse,
  MakePlanPrimaryRequest,
  MakePlanPrimaryResponse,
  ClearPrimaryRequest,
  ClearPrimaryResponse,
  ArchivePlanRequest,
  ArchivePlanResponse,
  PlanArchived,
  BulkArchivePlanRequest,
  BulkArchivePlanResponse,
  BulkPlanResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  ArrangePlansRequest,
  ArrangePlansResponse,
  CountPlansRequest,
  CountPlansResponse,
  GetPlansPremiumStatusRequest,
  GetPlansPremiumStatusResponse,
  SearchPlansRequest,
  SearchPlansResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  PlanBuyerCanCancelUpdatedEnvelope,
  PlanCreatedEnvelope,
  PlanArchivedEnvelope,
  PlanUpdatedEnvelope,
  ListPublicPlansOptions,
  PlansQueryResult,
  PlansQueryBuilder,
  PlanQuerySpec,
  ListPlansOptions,
  UpdatePlan,
} from './pricing-plans-v2-plan-plans.universal.js';
export { utils } from './pricing-plans-v2-plan-plans.universal.js';
export {
  PeriodUnitWithLiterals,
  AppliedAtWithLiterals,
  SortOrderWithLiterals,
  ArchivedFilterWithLiterals,
  PublicFilterWithLiterals,
  WebhookIdentityTypeWithLiterals,
  ListPublicPlansApplicationErrors,
  QueryPublicPlansApplicationErrors,
  QueryPublicPlansValidationErrors,
  GetPlanApplicationErrors,
  ListPlansApplicationErrors,
  ListPlansValidationErrors,
  GetPlanStatsApplicationErrors,
  CreatePlanApplicationErrors,
  CreatePlanValidationErrors,
  UpdatePlanApplicationErrors,
  UpdatePlanValidationErrors,
  SetPlanVisibilityApplicationErrors,
  MakePlanPrimaryApplicationErrors,
  ClearPrimaryApplicationErrors,
  ArchivePlanApplicationErrors,
  CommonQueryWithEntityContext,
  PlanQuery,
} from './pricing-plans-v2-plan-plans.universal.js';
